const UPDATES = [
  {
    version: 1,
    released: "03/31/2019",
    features: [
      {
        topic: "Create account",
        description: "opening the sign up to closed BETA"
      },
      {
        topic: "Profiles",
        description: "Added a basic profile page, showcasing the projects"
      },
      {
        topic: "New Homepage",
        description: "Showcasing recently added work."
      }
    ],
    sections: [
      {
        title: " "

        // items: ["Basic information can now be stored with the authentication"]
      }
      // {
      //   title: "Bug Fixes",
      //   items: [
      //     "Fixed a bug where the Canvas might appear blank when a document was moved between displays"
      //   ]
      // }
    ]
  },
  {
    version: 1.01,
    released: "03/29/2019",
    features: [
      {
        topic: "Project Creation",
        description: "storing additional information"
      }
    ],
    sections: [
      {
        title: "Enhancements",
        items: [
          "Added a 'Company URL' field to the project creation form",
          "Updated 'Category' field to 'Creative Discipline' to be more verbose"
        ]

        // items: ["Basic information can now be stored with the authentication"]
      }
      // {
      //   title: "Bug Fixes",
      //   items: [
      //     "Fixed a bug where the Canvas might appear blank when a document was moved between displays"
      //   ]
      // }
    ]
  },
  {
    version: 1.02,
    released: "04/02/2019",
    features: [
      {
        topic: "Usernames",
        description: "You can now choose a username when you create an account"
      }
    ],
    sections: [
      {
        title: "Enhancements",
        items: [
          "Responsive layout added for Homepage",
          "Responsive layout added for Login",
          "Responsive layout added for Sign up",
          "Responsive layout added for Onboarding"
        ]

        // items: ["Basic information can now be stored with the authentication"]
      }
      // {
      //   title: "Bug Fixes",
      //   items: [
      //     "Fixed a bug where the Canvas might appear blank when a document was moved between displays"
      //   ]
      // }
    ]
  }
];

export default UPDATES;
